import React, { FC } from "react";
import { Modal, useNotifications } from "sprint-common-web";

import { useFileRecordApi } from "../../../../../../../common/api/master-api/file-records/useFileRecordApi";
import { CourseOfActionReference } from "../../../../../../../common/types/CourseOfActionReference";
import { FixedBillingReference } from "../../../../../../../common/types/FixedBillingReferfence";
import { RejectionReasonReference } from "../../../../../../../common/types/RejectionReasonReference";
import { FileRecordStatusDetails } from "../../../../../common/types/FileRecordStatusDetails";
import { FileRecordRejectionReasonForm } from "../../../../../reject/FileRecordRejectionReasonForm";

type RejectStatusDialogProps = {
    fileRecordId: string;
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (statusDetails?: FileRecordStatusDetails) => void;
};

export const RejectStatusDialog: FC<RejectStatusDialogProps> = ({ fileRecordId, isOpen, onClose, onConfirm }) => {
    const { success, error } = useNotifications();
    const { rejectFileRecord } = useFileRecordApi();

    const handleFileRecordRejection = async ({
        reason,
        courseOfAction,
        fixedBilling,
        details
    }: {
        reason: RejectionReasonReference;
        courseOfAction: CourseOfActionReference;
        fixedBilling?: FixedBillingReference;
        details: string;
    }) => {
        try {
            await rejectFileRecord({
                fileRecordId,
                reasonId: reason.id,
                courseOfActionId: courseOfAction.id,
                fixedBillingId: fixedBilling?.id,
                details
            });

            onConfirm({
                reason: reason.name,
                courseOfAction: courseOfAction.name,
                fixedBilling: fixedBilling?.name,
                details
            });
            success("File record successfully rejected.");
        } catch (e) {
            console.log(e);
            error("File record rejection failure.");
        }

        onClose();
    };

    return (
        <Modal headerText="Reject file record" isBlocking={true} isOpen={isOpen} onDismiss={onClose}>
            <FileRecordRejectionReasonForm onConfirm={handleFileRecordRejection} onCancel={onClose} />
        </Modal>
    );
};
